export default __webpack_public_path__ + "static/media/logo.b9f5db9d.png";